import React from 'react'
import { useTranslation } from 'react-i18next'
import useSubscriptionInvoices from '../../../services/subscription/useSubscriptionInvoices'
import InvoicesTable from './InvoicesTable'
import LoadFailed from '../../UI/LoadFailed'

const InvoicesLoader = () => {
  const { t } = useTranslation()
  const {
    data: invoices,
    isLoading,
    isError,
    refetch,
  } = useSubscriptionInvoices()

  if (isError) {
    return (
      <div className='mt-10'>
        <LoadFailed message={t('failedToLoadInvoices')} onRetry={refetch} />
      </div>
    )
  }

  return (
    <div className='mt-10'>
      <InvoicesTable invoices={invoices ?? []} isLoading={isLoading} />
    </div>
  )
}

export default InvoicesLoader
